export default axios => ({
  getRecommendations: params => axios.get('ml-service/train/recommendations', { params }),

  deleteSubVersion: subVersion => axios.delete(`ml-service/versions/${subVersion.version.version}/${subVersion.sub_version}`),

  getRecognitionStatisticsByProject: params => axios.get('ml-service/statistic/recognition-history-marks/by-project', { params }),

  getRecognitionStatisticsByUser: params => axios.get('ml-service/statistic/recognition-history-marks/by-user', { params })
})
